import React from 'react'
import { Alert, Button, Col, Row, Form, FormGroup, FormLabel, FormControl, Modal } from 'react-bootstrap'
// import { ModalContainer, ModalDialog } from 'react-modal-dialog';

const SendReferralDialog = ({saveErrorMessage, onSaveClicked, onUpdateClicked, onCancelClicked, organizationId, organizationName, contactName, contactPhone}) => {
    const organizationNameInputRef = React.createRef();
    const contactNameInputRef = React.createRef();
    const contactPhoneInputRef = React.createRef();
    const saveButtonRef = React.createRef();

    const significantFieldChanged = () => {
        saveButtonRef.current.disabled = !(organizationNameInputRef.current.value && organizationNameInputRef.current.value.length > 0)
    }

    return (
    <div className="SaveOrganizationDialog">
        <Modal>
                <Modal.Header>
                    {(organizationName &&
                        <Modal.Title><h3>Update organization</h3></Modal.Title>)
                            ||
                        <div><h3>Create organization</h3></div>
                    }
                </Modal.Header>
                <Modal.Body>

                    {saveErrorMessage &&
                        <Alert variant="danger">{saveErrorMessage}</Alert>
                    }
                    <Form id="saveOrganizationForm" className="SaveOrganizationForm" style={{width: '360px'}}
                          onSubmit={(e)=>{
                              e.preventDefault();
                              e.stopPropagation();
                              onSaveClicked(organizationNameInputRef.current.value, contactNameInputRef.current.value, contactPhoneInputRef.current.value)
                          }}>
                            <Row>
                                <Col sm={12}>
                        <FormGroup controlId="formHorizontalOrganizationName">
                            <FormLabel>Organization name</FormLabel>
                            <FormControl type="text"
                                         ref={organizationNameInputRef}
                                         onKeyPress={(e) => {
                                             if (e.charCode === 13) {
                                                 e.preventDefault();
                                                 e.stopPropagation();
                                                 contactNameInputRef.focus();
                                             }
                                         }}
                                         onChange={()=>significantFieldChanged()}
                                         disabled={organizationName}
                                         value={organizationName}
                                         placeholder="Organization name"
                                         />
                        </FormGroup>
                        <FormGroup controlId="formHorizontalContactName">
                            <FormLabel>Contact person name</FormLabel>
                            <FormControl type="text"
                                         ref={contactNameInputRef}
                                         onKeyPress={(e) => {
                                             if (e.charCode === 13) {
                                                 e.preventDefault();
                                                 e.stopPropagation();
                                                 contactPhoneInputRef.current.focus();
                                             }
                                         }}
                                         defaultValue={contactName}
                                         placeholder="First and last name"
                                        />
                        </FormGroup>
                        <FormGroup controlId="formHorizontalContactPhone">
                            <FormLabel>Contact person phone</FormLabel>
                            <FormControl type="text"
                                         ref={contactPhoneInputRef}
                                         onKeyPress={(e) => {
                                             if (e.charCode === 13) {
                                                 e.preventDefault();
                                                 e.stopPropagation();
                                                 if (onSaveClicked) {
                                                     onSaveClicked(organizationNameInputRef.current.value, contactNameInputRef.current.value, contactPhoneInputRef.current.value)
                                                 } else if (onUpdateClicked) {
                                                     onUpdateClicked(organizationId, organizationNameInputRef.current.value, contactNameInputRef.current.value, contactPhoneInputRef.current.value)
                                                 }
                                             }
                                         }}
                                         defaultValue={contactPhone}
                                         placeholder="Phone number"
                                         />
                        </FormGroup>
                                </Col>
                            </Row>

                        <FormGroup>
                            <Row>
                                <Col smOffset={5} sm={7} style={{display: 'flex', justifyContent: 'flex-end'}} >
                                    <Button onClick={onCancelClicked} style={{marginLeft: '5px'}}>
                                        Cancel
                                    </Button>
                                    {(onUpdateClicked &&
                                        <Button variant={'primary'} style={{marginLeft: '5px'}} onClick={() => {
                                            onUpdateClicked(organizationId, organizationNameInputRef.current.value, contactNameInputRef.current.value, contactPhoneInputRef.current.value)
                                        }}>
                                            Update organization</Button>)
                                    ||
                                        <FormControl type={"submit"}
                                                     disabled
                                                     variant={'primary'}
                                                     style={{marginLeft: '5px'}}
                                                     value={"Create organization"}
                                                     ref={saveButtonRef}
                                                     onClick={(e) => {
                                                         e.preventDefault();
                                                         e.stopPropagation();

                                                     }}>
                                        </FormControl>
                                    }
                                </Col>
                            </Row>
                        </FormGroup>
                    </Form>
                </Modal.Body>
        </Modal>
    </div>
    )}
export default SendReferralDialog;